(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyUiSelectOptions", ['$timeout', function ($timeout) {
    return {
      restrict: "A",
      require: "uiSelect",
      scope: true,
      link: function ($scope, $element, $attrs, $select) {
        $timeout(function () {
          var uiSelect = angular.element($select.$element);
          // on contact type change, enquiry type dropdown option should be reset
          $scope.$watch("fields.contactType", function (newValue, oldValue, scope) {
            if ($select.itemProperty === "enquiryType") {
              $select.activeIndex = undefined;
            }
          });
          $scope.onOpenClose = function (isOpen) {
            if (!isOpen) {
              uiSelect.trigger("ui-select-blur", {});
            } else {
              uiSelect.trigger("ui-select-focus", {});
            }
          };

        });
      },
    };
  }]);
})(window.angular);
